import 'index.css';
import { seedHotelUuid } from './seedHotelUuid';

seedHotelUuid();
